import React, { useEffect, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import TopNav from 'components/TopNav';
import styles from '../styles.module.scss';
import { CircularProgress } from '@material-ui/core';
import { useQuery, useQueryClient } from 'react-query';
import { PROFILE, SEARCH_JOB_FILTER } from '../../../config/constants';
import { getLocalStorage } from '../../../utils/utils';
import * as searchApi from 'api/search';
import ListJob from '../../../components/Jobs/ListJob';
import isEmpty from 'lodash/isEmpty';
import Typography from '@material-ui/core/Typography';
import error from './../../../common/error';
import BottomNav from '../../../components/BottomNav';
import { getAllItemJobResource } from 'api/itemJobResources';
import * as agentResourceApi from '../../../api/agentResources';



function SearchJobResult(props) {
  const history = useHistory();
  const location = useLocation();
  const queryClient = useQueryClient();
  const rawJobSearchList = queryClient.getQueryData('jobSearchJobList');
  const rawMessage = queryClient.getQueryData('jobSearchJobListMessage');
  const rawMessageErr = queryClient.getQueryData('jobSearchJobListMessageErr');
  const { data: itemJobResources } = useQuery(['itemJobResource'], () => getAllItemJobResource(), { cacheTime: Infinity });

  const [jobSearchList, setJobSearchList] = useState();
  const [message, setMessage] = useState();

  useEffect(() => {
    if (!rawJobSearchList) {
      const fetch = async () => {
        const dataRaw = await getLocalStorage(SEARCH_JOB_FILTER);
        let data = {};
        if (dataRaw) {
          try {
            data = JSON.parse(dataRaw);
          } catch (e) {
            console.error(e);
          }
        }

        const { data: userSearchList, messageErr } = await searchApi.searchJob(data);
        setJobSearchList(userSearchList);
        if (!userSearchList.length) {
          setMessage(messageErr);
        }

      };
      fetch();
    } else {
      setJobSearchList(rawJobSearchList);
      if (!rawJobSearchList.length) {
        setMessage(rawMessageErr);
      }
    }
  }, [rawJobSearchList, rawMessage, rawMessageErr]);

  return (
    <div style={{ overflow: 'auto', height: '100vh' }}>
      <div className={styles.searchScreen}>
        <TopNav name={'仕事検索一覧（メンバー）'} hasBackIcon={true} dir={`${process.env.RAZZLE_PUBLIC_URL}/search-job`} />

        {jobSearchList === undefined ? (
          <div className={styles.loading}>
            <CircularProgress color="secondary" />
          </div>
        ) : (
          <div style={{ marginTop: 65, marginBottom: 60 }}>
            {isEmpty(jobSearchList) ? (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
                <center>
                  <Typography variant="h6" className="font-2">
                    {message}
                  </Typography>
                </center>
              </div>
            ) : (
              <ListJob jobList={jobSearchList}
                       history={history}
                       act=""
                       type="search-job-result"
                       agentResource={props?.agentResource ?? {}}
                       itemJobResources={itemJobResources?.data ?? []}
              />
            )}

          </div>
        )}

        <div className="d-btn-back-search">
          <Link className="btn btn-main"
                variant="contained"
                style={{
                  borderRadius: 30,
                  padding: '5px 20px',
                  height: 'unset',
                  width: 'unset',
                  textDecoration: 'unset',
                }}
                to={`${process.env.RAZZLE_PUBLIC_URL}/search-job`}>
            検索条件を変えて再検索
          </Link>
        </div>

        <BottomNav />
      </div>
    </div>
  );
}

SearchJobResult.getInitialProps = async ({
                                                req, res, match, history, location, ...ctx
                                              }) => {
  const agentResource = await agentResourceApi.getAllResource();
  const agentResourceShows = agentResource?.data
      ?.filter((item) => item.value === PROFILE.ROOT)
      .sort((a, b) => a.profileOrder - b.profileOrder);

  return {
    agentResource: {
      data: (agentResource?.data || []).map(e => {
        delete e?.id;

        return e;
      }),
      agentResourceShows
    },
  };
};

export default SearchJobResult;
